import { SubTypeOption } from "../../api/gms/group-category/group-category-api-state";
import { Checked } from "../../assets/icon/svg";

interface Props {
    disabled: boolean;
    isSelected: boolean;
    option: SubTypeOption;
    onChange: (e: React.ChangeEvent<HTMLInputElement>, value: SubTypeOption) => void;
}

export default function Checkbox({ disabled, isSelected, option, onChange }: Props) {
    return (
        <label
            key={option.id}
            className={`flex min-w-0 items-start gap-2 rounded border p-2 transition-all duration-200
                ${isSelected
                    ? 'border-[#186cb2] bg-[#186cb2]/10 shadow-sm'
                    : 'border-gray-200 bg-white'
                }
                ${disabled
                    ? 'cursor-not-allowed opacity-50'
                    : 'cursor-pointer hover:border-[#186cb2] hover:bg-gray-50'
                }
            `}
        >
            <input
                type="checkbox"
                disabled={disabled}
                checked={isSelected}
                onChange={(e) => {
                    if (disabled) return;
                    onChange(e, option)
                }}
                className='hidden'
            />
            <div
                className={`mt-0.5 flex h-3.5 w-3.5 shrink-0 items-center justify-center rounded-full border transition
                    ${isSelected
                        ? 'border-[#186cb2] bg-[#186cb2]'
                        : disabled
                            ? 'border-gray-300 bg-gray-100'
                            : 'border-gray-400 bg-white'
                    }
                `}
            >
                {isSelected && <Checked />}
            </div>
            <span className={`min-w-0 break-words text-xs leading-4
                ${ isSelected ? 'font-normal text-[#186cb2]' : 'text-gray-700' }
            `}>
                {option.name}
            </span>
        </label>
    )
}
